import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5c3fc2dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container-fluid message-container-align"
}
const _hoisted_2 = {
  key: 1,
  class: "container-fluid message-container-align"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = {
  key: 2,
  class: "container p-3",
  style: {"min-height":"363px"}
}
const _hoisted_8 = { href: "" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer15" }, null, -1))
const _hoisted_10 = { class: "verification-box" }
const _hoisted_11 = { class: "verification-header" }
const _hoisted_12 = { class: "verification-description" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer30" }, null, -1))
const _hoisted_14 = {
  id: "previousDownloads",
  class: "txtSize15"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer5" }, null, -1))
const _hoisted_16 = {
  id: "remainingDownloads",
  class: "txtSize15"
}

import { ref, onMounted, computed } from "vue";
import CryptoJS from "crypto-js";
import router from "@/router";
import { useI18n } from "vue-i18n";
import axios from "axios";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { generateChecksum } from "../services/generateChecksum";
import { decryptData } from "../services/decryptData";
import ErrorModal from "./ErrorModal.vue";

const __default__ = {
  name: "OtpGenerateComponent",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const otpErrorMessage = ref("");
const expiryDays = computed(() => userDocument?.value?.ExpiryDays);
const secretKey = process.env.VUE_APP_ENCRYPT_DECRYPT_SECRET_KEY;
const JwtSecretKey = process.env.VUE_APP_JWT_KEY;
const errorFlag = ref(false);
const otpErrorFlag = ref(false);
const unAuthorizedFlag = ref(false);
const store = useStore();
const loader = ref(false);
const { t } = useI18n();
const userDocument = ref<any | null>(null);
const invoiceDetail = ref<any | null>(null);
const downloadCount = computed(() => invoiceDetail?.value?.DownloadCount);
const remainingDownloads = computed(
  () => userDocument?.value?.MaxDownloads - invoiceDetail?.value?.DownloadCount
);
const linkExpiredFlag = ref(false);
const invalidIDFlag = ref(false);
const baseUrl = process.env.VUE_APP_BASE_API_URL;
const route = useRoute();
const userId = ref(route.query.p as string);

const getInvoiceCount = async (token: any) => {
  const checksumString = `${userId.value}`;
  const checksum = generateChecksum(checksumString);
  try {
    const invoiceCountDetail = await axios.get(
      `${baseUrl}/invoice/count/${userId.value}`,
      {
        headers: { Authorization: `Bearer ${token}`, "X-Checksum": checksum },
      }
    );
    const encryptedData = invoiceCountDetail.data;
    const decryptedText = decryptData(encryptedData);
    const receivedChecksum = invoiceCountDetail.headers["x-file-checksum"];
    const calculatedChecksum = generateChecksum(invoiceCountDetail.data);
    const invoiceData = JSON.parse(decryptedText);
    if (
      receivedChecksum === calculatedChecksum &&
      invoiceData.UserId === userId.value
    ) {
      invoiceDetail.value = invoiceData;
      loader.value = false;
    } else {
      loader.value = false;
      errorFlag.value = true;
    }
  } catch (error: any) {
    loader.value = false;
    errorFlag.value = true;
    console.error("Failed to fetch invoice details:", error);
  }
};
const getToken = async (token: any) => {
  token = "";
  try {
    const encryptedDataValue = {
      UserId: userId.value,
      SecretKey: JwtSecretKey,
      timestamp: new Date().toISOString(),
    };
    const dataString = JSON.stringify(encryptedDataValue);
    const encryptedDataString = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    const tokenResponse = await axios.post(`${baseUrl}/auth/generate-token`, {
      encryptedDataString,
    });
    token = tokenResponse.data.token;
    setTokenInSessionStorage(token, 23);
    return token;
  } catch (error: any) {
    console.error("Failed to generate token:", error);
    if (error.response) {
      if (error.response.status === 404 || error.response.status === 401) {
        unAuthorizedFlag.value = true;
      } else {
        errorFlag.value = true;
        throw new Error("Failed to generate token. Please try again.");
      }
    }
  }
};
const setTokenInSessionStorage = (token: any, expiresIn: number) => {
  const expirationTime = Date.now() + expiresIn * 3600 * 1000;
  sessionStorage.setItem(`token_${userId.value}`, token);
  sessionStorage.setItem(
    `tokenExpiration_${userId.value}`,
    expirationTime.toString()
  );
};

const getTokenFromSessionStorage = () => {
  const token = sessionStorage.getItem(`token_${userId.value}`);
  const expirationTime = parseInt(
    sessionStorage.getItem(`tokenExpiration_${userId.value}`) || "0"
  );

  if (Date.now() > expirationTime) {
    sessionStorage.removeItem(`token_${userId.value}`);
    sessionStorage.removeItem(`tokenExpiration_${userId.value}`);
    return null;
  }

  return token;
};

const fetchUserData = async () => {
  try {
    loader.value = true;
    let token = getTokenFromSessionStorage();

    if (!token) {
      token = await getToken(token);
    }
    const checksumString = `${userId.value}`;
    const checksum = generateChecksum(checksumString);
    try {
      const invoiceResponse = await axios.get(
        `${baseUrl}/invoice/${userId.value}`,
        {
          headers: { Authorization: `Bearer ${token}`, "X-Checksum": checksum },
        }
      );
      const encryptedData = invoiceResponse.data;
      const decryptedText = decryptData(encryptedData);
      const receivedChecksum = invoiceResponse.headers["x-file-checksum"];
      const calculatedChecksum = generateChecksum(invoiceResponse.data);
      const invoiceData = JSON.parse(decryptedText);
      if (
        receivedChecksum === calculatedChecksum &&
        invoiceData.UserId === userId.value
      ) {
        userDocument.value = invoiceData;
      } else {
        loader.value = false;
        errorFlag.value = true;
      }
    } catch (error: any) {
      console.error("Failed to fetch user data", error);
      if (error.response && error.response.status === 404) {
        invalidIDFlag.value = true;
        loader.value = false;
        throw new Error(
          "User ID not found. Please check the ID and try again."
        );
      } else {
        errorFlag.value = true;
        loader.value = false;
        throw new Error("Failed to fetch user data. Please try again later.");
      }
    }
    await getInvoiceCount(token);
    const currentDate = new Date();
    const expiryDate = new Date(userDocument.value.ExpiryDate.value);
    if (userDocument.value?.publicUrl) {
      store.commit("setUserID", userDocument.value.Id);
      if (currentDate > expiryDate) {
        linkExpiredFlag.value = true;
        return;
      } else {
        store.commit("setAuth", true);
        router.push({ name: "PDFDownloadPage", query: { p: userId.value } });
      }

      return;
    }

    if (currentDate > expiryDate) {
      linkExpiredFlag.value = true;
      return;
    }
  } catch (error: any) {
    error.value =
      error.message || "An unexpected error occurred. Please try again later.";
    loader.value = false;
  } finally {
    loader.value = false;
  }
};
onMounted(() => {
  if (store.state.isOtpGenerateAuth) {
    fetchUserData();
  } else {
    loader.value = false;
    invalidIDFlag.value = true;
  }
});
const validateGenerateOtp = async () => {
  const checksumString = `${userId.value}`;
  const checksum = generateChecksum(checksumString);
  let token = getTokenFromSessionStorage();
  if (!token) {
    token = await getToken(token);
  }
  try {
    const otpDetails = await axios.get(`${baseUrl}/generate/${userId.value}`, {
      headers: { Authorization: `Bearer ${token}`, "X-Checksum": checksum },
    });
    console.log("OTP generate api Response:", otpDetails.data);
    const encryptedData = otpDetails.data;
    const decryptedText = decryptData(encryptedData);
    const receivedChecksum = otpDetails.headers["x-file-checksum"];
    const calculatedChecksum = generateChecksum(otpDetails.data);
    const otpData = JSON.parse(decryptedText);
    if (
      receivedChecksum === calculatedChecksum &&
      otpData.UserId === userId.value
    ) {
      if (otpData.Status.toLowerCase() === "success") {
        store.commit("setOtpGenerateAuth", false);
        store.commit("setOtpValidateAuth", true);
        store.commit("setOtpData", {
          method: otpData.OtpMethod,
          prompt: otpData.OtpPrompt,
        });
        loader.value = false;
        router.push({ name: "OtpValidate", query: { p: userId.value } });
      } else {
        otpErrorMessage.value = otpData.OtpData.errorReason;
        loader.value = false;
        otpErrorFlag.value = true;
        return;
      }
    } else {
      loader.value = false;
      errorFlag.value = true;
    }
  } catch (error: any) {
    loader.value = false;
    errorFlag.value = true;
    console.error("Failed to fetch Otp details:", error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_b_spinner, {
            style: {"width":"6rem","height":"6rem","color":"#003778"},
            label: "Large Spinner"
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(ErrorModal, {
      modelValue: otpErrorFlag.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((otpErrorFlag).value = $event)),
      message: otpErrorMessage.value
    }, null, 8, ["modelValue", "message"]),
    (linkExpiredFlag.value || invalidIDFlag.value || errorFlag.value || unAuthorizedFlag.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (unAuthorizedFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_unref(t)("form.unauthorized")), 1))
            : _createCommentVNode("", true),
          (linkExpiredFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_unref(t)("form.yourlinkhasexpired")), 1))
            : _createCommentVNode("", true),
          (invalidIDFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_unref(t)("form.invalidrequest")), 1))
            : _createCommentVNode("", true),
          (errorFlag.value && !unAuthorizedFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_unref(t)("form.unabletoprocesstherequest")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (
      !loader.value &&
      !linkExpiredFlag.value &&
      !invalidIDFlag.value &&
      !errorFlag.value &&
      !unAuthorizedFlag.value
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_unref(t)("otpGenerate.verificationMessage")) + " ", 1),
            _createElementVNode("a", _hoisted_8, _toDisplayString(expiryDays.value) + " " + _toDisplayString(_unref(t)("form.days")), 1),
            _createTextVNode(". ")
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h5", _hoisted_11, _toDisplayString(_unref(t)("otpGenerate.verificationRequired")), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)("otpGenerate.receiveOneTimeCode")), 1),
            _createVNode(_component_b_button, {
              pill: "",
              class: "custom-button",
              onClick: validateGenerateOtp
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("otpGenerate.sendOneTimeCode")), 1)
              ]),
              _: 1
            })
          ]),
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)("download.previousdownloads")) + ": " + _toDisplayString(downloadCount.value), 1),
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)("download.remainingdownloads")) + ": " + _toDisplayString(remainingDownloads.value), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})